import { useState } from 'react';
import ChevronDownIcon from './icons/ChevronDownIcon';
import ChevronUpIcon from './icons/ChevronUpIcon';

type Props = {
  children: React.ReactNode;
  expandContent: string;
  collapseContent: string;
};
const Accordion = ({ children, expandContent, collapseContent }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="flex w-full flex-col justify-end gap-1">
      <button
        onClick={toggleCollapse}
        className="rounded bg-blue-500 py-2 text-black hover:bg-blue-700"
      >
        {isCollapsed ? (
          <button className="text-primary-60 flex w-full content-center items-center justify-end gap-2">
            <p className="text-md font-semibold">{expandContent}</p>
            <ChevronDownIcon color="#ff7f32" className="h-[18px] w-[18px]" />
          </button>
        ) : (
          <button className="text-primary-60 flex w-full items-center justify-end gap-2">
            <p className="text-md font-semibold">{collapseContent}</p>
            <ChevronUpIcon color="#ff7f32" className="h-[18px] w-[18px]" />
          </button>
        )}
      </button>
      {isCollapsed ? (
        <div className="hidden">{children}</div>
      ) : (
        <div className="flex w-full flex-col justify-end gap-4">{children}</div>
      )}
    </div>
  );
};

export default Accordion;
